import React from 'react';
import Link from "next/link";
import styled, {keyframes} from "styled-components";
import ApplicantGif from "../lotties/applicant";
import useTrans from "../../hooks/translation";
import {isEmpty} from "../../helpers/helpers";
import {useWindowSize} from "../../helpers/windows.size";
import {inArray} from "../../helpers/arrays";
import {checkUserModality} from "@organisms/property/helpers/property_helpers";
import {handleShowInvestmentModalTrack} from "@organisms/property/invest/investment_tracks";
import Icon from "../../atoms/icon";
import {formatPhoneNumber} from "../../helpers/numbers";
import ChevronLeftIcon from '@icons/chevron-left.svg';
import PhoneIcon from '@icons/phone.svg';

function InvestmentBannerGridWithLottie({city_id, propertyTypes, propertyDealType, districts, isBadeSaba = false, eventSection, eventView, addParamsToUrl, investmentPhoneNumber}) {
    const windowSize = useWindowSize();

    const modalityData = {
        city_id: city_id,
        district_id: districts,
        deal_type: propertyDealType
    };

    const checkShowInvestBanner = checkUserModality(modalityData, true);

    const handleTitle = () => {
        const rentDealTypes = ['mortgage', 'rent'];
        const $dealType = inArray(propertyDealType, rentDealTypes) ? 'rent' : 'sale';

        let title = '';
        title += useTrans('deal_type.limit.' + $dealType);

        title += ' خانه';

        if (!isEmpty(districts) && districts.length && windowSize > 991 && city_id === 207) {
            title += ' در';
            for (let key in districts) {
                const district = districts[key];
                const districtName = !isEmpty(district.label) ? district.label : (!isEmpty(district.name) ? district.name : '');

                if (districts.length <= 2 || (districts.length > 2 && Number(key) < 2)) {
                    title += ((key == 0) ? ' ' : '، ') + districtName;
                } else if (districts.length > 2 && Number(key) === 2) {
                    title += ' و...';
                }
            }
        } else if (windowSize > 991 && city_id === 262) {
            title += ' در گلبهار';
        }

        return title;
    };

    const checkCity = (city_id) => {
        const cities = [
            207, // مشهد
            262, // گلبهار
        ];

        return inArray(city_id, cities);
    };

    const handleBannerEvent = () => {
        const eventData = {
            city_id,
            event_section: 'properties',
            event_view: 'list',
            event_position: 'banner-link-to-investment'
        };

        handleShowInvestmentModalTrack(eventData);
    };

    if (checkShowInvestBanner.show_invest && checkCity(city_id)) {
        return (
            <Link href="/home/landing/applicant" as={`/investment` + (!isEmpty(addParamsToUrl) ? addParamsToUrl : '')}>
                <a onClick={() => handleBannerEvent()}>
                    <Container className="cursor-pointer rounded-8 mt-24 pl-24 pr-16 px-lg-56 d-flex align-items-center">
                        <ApplicantGifSection className="">
                            <ApplicantGif width={(windowSize > 991) ? 130 : 75} height={'100%'}/>
                        </ApplicantGifSection>

                        <div className="investment-banner-content d-flex align-items-center justify-content-start justify-content-lg-between w-100 mr-16 mr-lg-48">
                            <div className="d-block d-lg-flex flex-column ">
                                <span className="text-white h3-normal">قبل از {handleTitle()}، </span>
                                <span className="text-white h1-normal">
                        از ۲نبش          <span className="special-realtors-color">مشاوره تخصصی</span> بگیرید

                                    {
                                        (windowSize < 992) ?
                                            <Icon width={12} height={12} className="mr-8 icon-chevron-left"><ChevronLeftIcon/></Icon>
                                            : '.'
                                    }
                                </span>

                                {
                                    !isEmpty(investmentPhoneNumber) ?
                                        <a href={"tel:" + investmentPhoneNumber} className="d-flex align-items-center h2-normal investment-phone-number">
                                            <Icon width={16} className="ml-8 phone-icon"><PhoneIcon/></Icon>
                                            {formatPhoneNumber(investmentPhoneNumber)}
                                        </a>
                                        : ''
                                }
                            </div>

                            {
                                (windowSize > 991) ?
                                    <Icon width={48} height={48} className="icon-chevron-left"><ChevronLeftIcon/></Icon>
                                    : ''
                            }
                        </div>
                    </Container>
                </a>
            </Link>
        )
    } else {
        return ''
    }
}

export default React.memo(InvestmentBannerGridWithLottie);

// styles

const nudge = keyframes`
 
    0% {
        transform: translate(10px, 0);
    }
      
    100% {
        transform: translate(-10px, 0);
    }
`;

const ApplicantGifSection = styled.div`
    & > div {
        display: flex;
        align-items: center;
    }
`;

const Container = styled.div`
    position: relative;
    background-color: #374045;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    height: 164px;
    
    .investment-banner-content {
         .special-realtors-color {
              color: ${props => props.theme.yellow} !important;
         }
         
         .icons.icon-chevron-left {
             //animation: ${nudge} 1s ease infinite alternate;
             //animation: ${nudge} 1s linear infinite alternate;
             animation: ${nudge} 1s ease-out infinite alternate;
         
            svg {
                path {
                    stroke: #ffffff;
                    stroke-width: .6;
                }
            }
         }
         
         .investment-phone-number {
              color: #ffffff !important;
             
             .icons.phone-icon {
                svg {
                    path {
                        stroke: #ffffff;
                    }
                }
                
                @media (max-width: ${props => props.theme.screenSmMax}) {
                    width: 12px;
                    min-width: 12px;
                    max-width: 12px;
                }
             } 
         }
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        height: 120px;
        
        .h1-normal, .h3-normal {
             font-size: 15px; 
        }
        
        .investment-banner-content {
            
             .icons.icon-chevron-left {
                position: relative;
                top: 3px;
                animation: ${nudge} 0s ease-out infinite alternate;
                
                svg {
                    path {
                        stroke-width: 1;
                    }
                }
             }
        }
    }
`;